// extracted by mini-css-extract-plugin
export default {"container":"WyIoWsivxglppNaM9oXpgw==","image":"vKpzBY07bsGfBoC7qznL4w==","textContainer":"R9B-9gZc5YDSQn6VAABW4Q==","qontoHeader":"pyWi5Kzks3xaECNPprJJ3A=="};